import { statusIconId } from './constants.js';
import { resolveRoomStatus } from './status.js';
import type {
  FetcherContext,
  ReservableRoom,
  RoomFeature,
  RoomStatus,
  RoomWithGeometry,
} from './types.js';

export const buildRoomFeatures = (
  roomsWithGeometry: RoomWithGeometry[],
  availability: Map<string, ReservableRoom>,
  context: FetcherContext,
) => {
  const currentStatuses: Record<string, RoomStatus> = {};
  let statusesChanged = false;

  const features: RoomFeature[] = roomsWithGeometry.map(({ room, geometry }) => {
    const shortName = room.properties.name;
    const nextStatus = resolveRoomStatus(shortName, availability);
    const roomId = room.id;

    currentStatuses[roomId] = nextStatus;
    if (!statusesChanged && context.state.previousStatuses[roomId] !== nextStatus) {
      statusesChanged = true;
    }

    return {
      type: 'Feature',
      id: roomId,
      geometry,
      properties: {
        roomId,
        shortName,
        floorCode: Number.parseInt(room.properties.floor, 10),
        status: nextStatus,
        iconImage: statusIconId(nextStatus),
        labelStylePosition: 'center',
      },
    } as RoomFeature;
  });

  for (const roomId of Object.keys(context.state.previousStatuses)) {
    if (!(roomId in currentStatuses)) {
      statusesChanged = true;
      break;
    }
  }

  for (const roomId of Object.keys(context.state.previousStatuses)) {
    if (!(roomId in currentStatuses)) {
      delete context.state.previousStatuses[roomId];
    }
  }

  for (const roomId of context.state.missingGeometry) {
    delete context.state.previousStatuses[roomId];
  }

  Object.assign(context.state.previousStatuses, currentStatuses);

  return { features, statusesChanged };
};
